wbApp.directive('wbTerminalCombo', ['$timeout', '$translate', '$filter', 'terminalSvc',
    function ($timeout, $translate, $filter, terminalSvc) {
        function formatResult(terminal) {
            if (!terminal) { return; }

            return terminal.name;
        }

        function formatSelection(terminal) {
            return terminal.name;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {

                var terminals = terminalSvc.getAllAsync();

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_LBL_TERMINAL'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        id: function (terminal) { return terminal.terminalID; },
                        data: terminals
                    });

                    ctrl.$render();
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return null;
                    } else {
                        return parseInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return null;
                    } else {
                        return value + "";
                    }
                });

                ctrl.$render = function () {
                    terminals.$promise.then(function () {
                        $(elm).select2('val', ctrl.$viewValue);
                    });
                }

                elm.on('change', function (e) {
                    scope.$apply(function () {
                        ctrl.$setViewValue(e.val);                        
                    });
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);